import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
/**
 *  Zum Sicherstellen, dass für den gesamten Ladevorgang auch der Status "true" zurückkommt.
 *  Bei einer Suche kann es ansonsten zum Beispiel passieren,
 *  dass durch mehrere GET-Requests zu früh das Ergebnis "false" zurückgegeben wird.
 *
 *  BEGRÜNDUNG: Es handelt sich um eine Angular-Komponente, weshalb keine AFO erfüllt wird.
 */
export class LoadingService {
  private loadingCount = 0;
  private readonly _isLoading = new BehaviorSubject<boolean>(false);
  isLoading$ = this._isLoading.asObservable();

  start(): void {
    this.loadingCount++;
    this._isLoading.next(true);
  }

  stop(): void {
    this.loadingCount = Math.max(0, this.loadingCount - 1);
    if (this.loadingCount === 0) {
      this._isLoading.next(false);
    }
  }
}
